export default function useDataConfiguration({ thread_id }) {
  return {
    variables: {
      id: thread_id,
    },
    pause: !thread_id,
  }
}
